import {User} from '../models/User';
import Api from "./Api";

export default class EnvProvider {
    private readonly prod: boolean;
    private readonly uat: boolean;
    private readonly v1Api: string;
    private readonly v2Api: string;
    private _user: User | undefined;
    private _activities:any[] = [];
    private _caseManagers:any[] = [];

    constructor() {
        console.log('EnvProvider: Raw environment variables:');
        console.log('  process.env.REACT_APP_PROD:', process.env.REACT_APP_PROD);
        console.log('  process.env.REACT_APP_UAT:', process.env.REACT_APP_UAT);
        console.log('  process.env.NODE_ENV:', process.env.NODE_ENV);
        
        this.prod = `${process.env.REACT_APP_PROD}`.trim() === 'true';
        this.uat = `${process.env.REACT_APP_UAT}`.trim() === 'true';
        
        console.log('EnvProvider: Parsed boolean values:');
        console.log('  this.prod:', this.prod);
        console.log('  this.uat:', this.uat);
        
        if (this.prod) {
            // Production environment
            console.log('EnvProvider: Initializing PRODUCTION environment');
            this.v1Api = 'https://timeapi.jurismedicus.net';
            this.v2Api = 'https://jm.ktech.dev/api';
        } else if (this.uat) {
            // UAT environment
            console.log('EnvProvider: Initializing UAT environment');
            //this.v1Api = `https://jurismedicuscalendarv2-env-uat.eba-2d7ccefj.us-east-2.elasticbeanstalk.com/api`;
            //this.v2Api = `https://jurismedicuscalendarv2-env-uat.eba-2d7ccefj.us-east-2.elasticbeanstalk.com/api`;
            this.v1Api = `https://d3gdln7y45zavs.cloudfront.net/api`;
            this.v2Api = `https://d3gdln7y45zavs.cloudfront.net/api`;
        } else {
            // Development environment (pointing to UAT for testing)
            console.log('EnvProvider: Initializing DEVELOPMENT environment');
           //this.v1Api = `https://7vinxrltla.execute-api.us-east-2.amazonaws.com/${process.env.REACT_APP_API_STAGE}`;
           // this.v2Api = 'http://localhost:8666/api';

            this.v1Api = `https://d3gdln7y45zavs.cloudfront.net/api`;
            this.v2Api = `https://d3gdln7y45zavs.cloudfront.net/api`;
        }
        
        console.log('EnvProvider: Environment config - PROD:', this.prod, 'UAT:', this.uat, 'DEV:', !this.prod && !this.uat);
        console.log('EnvProvider: V1 API:', this.v1Api);
        console.log('EnvProvider: V2 API:', this.v2Api);
    }


    get user(): User | undefined {
        return this._user;
    }

    get activities(): any[] {
        return this._activities;
    }

    get caseManagers(): any[] {
        return this._caseManagers;
    }

    set user(value: User | undefined) {
        this._user = value;
    }

    set activities(value: any[]) {
        this._activities = value;
    }

    set caseManagers(value: any[]) {
        this._caseManagers = value;
    }

    public buildApi(user: User | undefined): Api {
        return new Api({
            baseUrl: this.v2Api,
            platform: 'web',
            version: `${process.env.REACT_APP_VERSION}`,
            user: user || this._user
        });
    }

    public buildLegacyApi(): Api {
        return new Api({
            baseUrl: this.v1Api,
            platform: 'web',
            version: `${process.env.REACT_APP_VERSION}`,
            user: this._user,
        });
    }
}
